<style lang="scss" scoped>
@import "./loader";
</style>

<script>
export default {
  name: 'Loader',

  created: function () {
    window.onload = function () {
      if (document.getElementById('#loading')) {
        document.getElementById('#loading').show()
      }
    }
  }
}
</script>

<template>
  <div class="block d-flex justify-content-center">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <div
        class="spinner-border text-light loader"
        role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="src-loader-label">
        <strong class="text-light h5">
          {{ $t("header.loader") }}
        </strong>
      </div>
    </div>
  </div>
</template>
